module.exports = __webpack_public_path__ + "img/targeting.e38bbb6f.svg";